import ProgressBar from 'react-bootstrap/ProgressBar';
import { Link } from 'react-router-dom';
export default function HomeFourTeam(){
    return(
        <>
            <section className="team-area4 pt-120 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30 home-4">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title text-center mb-55">
							<h6 className="semi-title mb-10">Team Members</h6>
							<h2 className="sect-title">Our Digital Experts</h2>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-3 col-lg-6 col-md-6">
						<div className="team-wrapper4 mb-30">
							<div className="team-thumb4">
								<Link to="/team-details"><img className="img-fluid" src="assets/img/home-4/hands.webp" alt="Team Img" /></Link>
							</div>
							<div className="team-content4">
								<h3><Link to="/team-details">Richard John</Link></h3>
								<h6>Founder</h6>
								<div className="footer__social4 mt-30">
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-facebook-f"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-twitter"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-linkedin-in"></i></Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6">
						<div className="team-wrapper4 mb-30">
							<div className="team-thumb4">
								<Link to="/team-details"><img className="img-fluid" src="assets/img/home-4/young.webp" alt="Team Img" /></Link>
							</div>
							<div className="team-content4">

								<h3><Link to="/team-details">Larry Mord</Link></h3>
								<h6>CEO</h6>
								<div className="footer__social4 mt-30">
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-facebook-f"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-twitter"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-linkedin-in"></i></Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6">
						<div className="team-wrapper4 mb-30">
							<div className="team-thumb4">
								<Link to="/team-details"><img className="img-fluid" src="assets/img/home-4/man.webp" alt="Team Img" /></Link>
							</div>
							<div className="team-content4">
								<h3><Link to="/team-details">John Milo</Link></h3>
								<h6>CTO</h6>
								<div className="footer__social4 mt-30">
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-facebook-f"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-twitter"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-linkedin-in"></i></Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-3 col-lg-6 col-md-6">
						<div className="team-wrapper4 mb-30">
							<div className="team-thumb4">
								<Link to="/team-details"><img className="img-fluid" src="assets/img/home-4/horizontal.webp" alt="Team Img" /></Link>
							</div>
							<div className="team-content4">
								<h3><Link to="/team-details">Tom Ashik</Link></h3>
								<h6>Developer</h6>
								<div className="footer__social4 mt-30">
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-facebook-f"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-twitter"></i></Link>
									<Link className="footer-icon" to="#"><i aria-hidden="true" className="fab fa-linkedin-in"></i></Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="content-area">
					<div className="row">
						<div className="col-lg-6">
							<div className="section-content">
								<div className="content-inner">
									<h2 className="content">
										Experience design &amp; intelligent marketing for growing brands.
									</h2>
									<div className="content-btn">
										<Link className="section-btn" to="/contact">Contact Today</Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-6 col-md-12 order-last">
							<div className="team-skill-wrapper overflow-hidden pr-100 pt-md-80 mb-30">
								<div className="comic-progress-bar mb-35">
									<h5 className="p-title">Design</h5>
									<div className="progress-team">
										<div className="progress-bar">
											<span>87%</span>
											<ProgressBar variant="success" now={87} />
										</div>
									</div>
								</div>
								<div className="comic-progress-bar bar-2 mb-35">
									<h5 className="p-title">Development</h5>
									<div className="progress-team">
										<div className="progress-bar">
											<span>95%</span>
											<ProgressBar variant="success" now={95} />
										</div>
									</div>
								</div>
								<div className="comic-progress-bar bar-3">
									<h5 className="p-title">Marketing</h5>
									<div className="progress-team">
										<div className="progress-bar">
										<span>95%</span>
										<ProgressBar variant="success" now={95} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}